<template>
  <v-app light>
    <v-app-bar app :src="getBannerSrc()" :height="100" flat>
      <template v-slot:img="{ props }">
        <v-img v-bind="props"></v-img>
      </template>
    </v-app-bar>
    <v-content>
      <v-container v-show="!showCounter" fluid>
        <v-row align="end">
          <v-card class="mx-auto" align="center" flat>
            <qrcode-vue :value="posTransactionId" size="100" level="H"></qrcode-vue>
            <v-card-text class="headline font-weight-bold" align="center">
              <div>{{ labels.completed[language] }}
                <br />
                {{ labels.serialNo[language] }}：{{ posTransactionId }}
              </div>
            </v-card-text>
          </v-card>
        </v-row>
      </v-container>
      <v-container fluid v-show="showCounter">
        <v-row>
          <v-card class="mx-auto" max-width="800" align="center" flat>
            <v-card-text class="title font-weight-bold primary--text pa-0" align="center">
              <div>{{ labels.takeReceiptAndPay[language] }}</div>
            </v-card-text>
            <vue-barcode v-show="subStores.length === 0" height="60px" :value="posTransactionId"></vue-barcode>
            <qrcode-vue v-show="subStores.length" :value="subStoreQrcodeInfo" size="120" level="H"></qrcode-vue>
            <v-card-text v-show="subStores.length" class="title font-weight-bold primary--text pa-0" align="center">
              <div>{{ posTransactionId }}</div>
            </v-card-text>
            <v-card-text v-show="externalPosBarcodeInfo.value" class="title font-weight-bold primary--text pa-0"
              align="center">
              <div>{{ externalPosBarcodeInfo.label }}</div>
            </v-card-text>
            <vue-barcode height="60px" v-show="externalPosBarcodeInfo.value"
              :value="externalPosBarcodeInfo.value"></vue-barcode>
            <v-card-text class="subtitle-1 font-weight-bold" align="center">
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th width="40%" class="text-center subtitle-1">{{ labels.item[language] }}</th>
                      <th class="text-center subtitle-1">{{ labels.remark[language] }}</th>
                      <th width="20%" class="text-center subtitle-2">
                        {{ labels.amount[language] }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in detailItems" :key="index">
                      <td>{{ item.name }}</td>
                      <td>{{ item.remark }}</td>
                      <td>{{ item.amount }}</td>
                    </tr>
                    <tr>
                      <td colspan="3" class="font-weight-bold">
                        {{ labels.serviceFee[language] }}：{{ printData ? printData.serviceCharge :
                          tContent.totalServiceFee }}
                      </td>
                    </tr>
                    <tr>
                      <td colspan="3" class="font-weight-bold title primary--text">
                        {{ labels.total[language] }}：{{ printData ? printData.total : tContent.total }}
                      </td>
                    </tr>
                    <template v-if="hasCurrentOrder">
                      <tr>
                        <td colspan="3" class="font-weight-bold">{{ `總服務費 ：${current.totalServiceFee}` }}</td>
                      </tr>
                      <tr>
                        <td colspan="3" class="font-weight-bold title primary--text">{{ `總金額 ：${current.total}` }}</td>
                      </tr>
                    </template>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card-text>
          </v-card>
        </v-row>
      </v-container>
    </v-content>
    <!--        <v-footer padless app color="white">
            <v-container fluid>
                <v-row class="pa-0">
                    <v-col class="pr-0 pl-0">
                        <v-btn class="subtitle-1 font-weight-bold" color="primary" @click="home"
                               block outlined>{{ labels.home[language] }}
                        </v-btn>
                    </v-col>
                </v-row>
            </v-container>
        </v-footer>-->
  </v-app>
</template>

<script>
import QrcodeVue from 'qrcode.vue';
import VueBarcode from 'vue-barcode';
import { deepCopy } from '../assets/functions/deepCopy';

const base64Encode = (str) => Buffer.from(str, 'utf-8').toString('base64');

function parsetContent(_items) {
  const items = deepCopy(_items);
  const arr1 = [];
  const group = {};
  items.forEach((item) => {
    if (item.isGroup === 'Y') {
      const main = item.groupNo.split('-')[0];
      if (Object.prototype.hasOwnProperty.call(group, main)) {
        group[main].remark += `, ${item.product.productName}`;
        const { subTotal } = item;
        if (subTotal !== '') {
          group[main].amount = subTotal;
        }
      } else {
        group[main] = {
          name: item.productGroupName,
          remark: item.product.productName,
          amount: item.subTotal,
        };
      }
    } else {
      arr1.push({
        name: item.product.productName,
        remark: '',
        amount: item.subTotal,
      });
    }
  });
  const arr2 = Object.keys(group).map((i) => group[i]);
  const result = [...arr1, ...arr2];
  return result;
}

function parseDetailItem(items) {
  return items.map((item) => {
    if (item.isGroup === 'Y') {
      // 套餐
      return {
        name: item.productGroupName,
        remark: item.Ingredients_remark,
        amount: item.item_total_money,
      };
    }
    // 單點
    // 附加註記
    const itemAdditional = ['1', '2', '3', '4', '5'].reduce((accu, curr) => {
      const additionalItems = item.product[`additionalOfProduct${curr}`];
      if (additionalItems && additionalItems.products) {
        const _addName = additionalItems.products.reduce((_accu, _curr) => `${_accu} ${_curr.productName}`, '');
        return `${accu} ${_addName}`;
      }
      return accu;
    }, '');

    return {
      name: item.product.productName,
      remark: itemAdditional,
      amount: item.item_total_money,
    };
  });
}

export default {
  name: 'PaymentPage',
  components: {
    QrcodeVue,
    VueBarcode,
  },
  props: {},
  data: () => ({
    labels: {
      completed: {
        en_US: 'Completed',
        zh_TW: '點餐完成',
      },
      takeReceiptAndPay: {
        en_US: 'Please show this barcode to our staff',
        zh_TW: '請持訂單至櫃檯結帳',
      },
      home: {
        en_US: 'HOME',
        zh_TW: '返回首頁',
      },
      serialNo: {
        en_US: 'No.',
        zh_TW: '訂單編號',
      },
      item: {
        en_US: 'ITEM',
        zh_TW: '品項',
      },
      remark: {
        en_US: 'REMARK',
        zh_TW: '註記',
      },
      amount: {
        en_US: 'AMOUNT',
        zh_TW: '金額',
      },
      total: {
        en_US: 'TOTAL',
        zh_TW: '本次總計',
      },
      order: {
        en_US: 'ORDER',
        zh_TW: '訂購明細',
      },
      serviceFee: {
        en_US: 'Tip',
        zh_TW: '本次服務費',
      },
    },
    showCounter: false,
    qrCodeValue: '',
    hasCurrentOrder: false,
    current: {
      totalAmount: 0,
      totalServiceFee: 0,
      total: 0,
    },
  }),
  methods: {
    getBannerSrc() {
      const setting = this.$store.getters.storeSetting;
      if (setting.kioskHomePageBanner) {
        return setting.kioskHomePageBanner.url + setting.kioskHomePageBanner.file_name;
      }
      return '';
    },
    handleDialogClose() {
      this.dialogPayment = false;
    },
    home() {
      const {
        no,
        extPos,
      } = this.$store.getters;
      this.$store.dispatch('cleanOrder');
      let homeUrl = `/?no=${base64Encode(no)}`;
      if (extPos && extPos.ext) {
        homeUrl += `&ext=${base64Encode(extPos.ext)}`;
      }
      this.$router.replace(homeUrl);
    },
  },
  mounted() {
    this.$store.dispatch('setStatus', 'DONE');
    const {
      diningIn,
      order: { paymentType },
    } = this.$store.getters;
    this.showCounter = (paymentType.name === 'counter' || paymentType.name === 'prepaid');
    if (diningIn === 'delivery') {
      this.labels.takeReceiptAndPay.zh_TW = '訂購完成';
    }
    if (this.isForKiosk) {
      this.labels.takeReceiptAndPay.zh_TW = '請持訂單條碼至自助繳費機結帳';
    }
    if (paymentType.name === 'linepay') {
      // 5秒後回首頁
      setTimeout(this.home(), 3000);
    }
    if (this.tContent?.transactionPaymentList[0]) {
      if (this.tContent?.transactionPaymentList[0].paymentTypeName === 'TapPay') {
        this.showCounter = true;
        this.labels.takeReceiptAndPay.zh_TW = '訂購完成';
      }
    }
    // 加點
    const { currentOrder, tContent } = this.$store.getters;
    if (currentOrder.length > 0) {
      this.hasCurrentOrder = true;
      const data = deepCopy(tContent);
      this.current.totalAmount = data.receiveTotal;
      this.current.totalServiceFee = data.serviceCharge;
      this.current.total = (this.current.totalAmount + this.current.totalServiceFee);
      data.log = currentOrder;
      data.totalAmount = this.$store.getters.totalAmount;
      data.totalServiceFee = this.$store.getters.totalServiceFee;
      data.total = (this.$store.getters.totalAmount + this.$store.getters.totalServiceFee);
      this.$store.dispatch('settContent', data);
    }
  },
  computed: {
    tContent() {
      return this.$store.getters.tContent;
    },
    language() {
      return this.$store.getters.language;
    },
    processStatus: {
      get() {
        return this.$store.getters.statusText;
      },
    },
    printData: {
      get() {
        return this.$store.getters.posResponse
          ?.defaultRabitmqDetail?.['print_data']?.printData || null;
      },
    },
    detailItems: {
      get() {
        if (this.$store.getters.posResponse
          ?.defaultRabitmqDetail?.['print_data'].printData?.['temp_log']) {
          return parseDetailItem(this.$store.getters.posResponse
            ?.defaultRabitmqDetail?.['print_data'].printData?.['temp_log']);
        }
        return parsetContent(this.$store.getters.tContent.log);
      },
    },
    posTransactionId: {
      get() {
        return this.$store.getters.posResponse?.defaultRabitmqDetail?.['print_data']?.printData?.clientTransactionId
          || this.$store.getters.tContent.clientTransactionId;
      },
    },
    subStoreQrcodeInfo() {
      return `${btoa(this.$store.getters.no)}#${this.posTransactionId}`;
    },
    externalPosBarcodeInfo() {
      const { extPos } = this.$store.getters;
      const info = {
        label: '',
        value: '',
      };
      if (extPos && extPos.counterNo && extPos.func) {
        info.label = this.$store.getters.extPos.label;
        info.value = extPos.func.ticketCode(extPos.counterNo, this.printData.total);
      }
      return info;
    },
    subStores() {
      return this.$store.getters.subStores;
    },
    isForKiosk: {
      get() {
        return this.$store.getters.isForKiosk;
      },
    },
  },
};
</script>
<style></style>
